// @module NXTurn.ShoppingExtensions.LoginRegister
define('C3.ShoppingExtensions.CartPage.QuickAdd.View'
,	[
	   'c3_shoppingextensions_cartpage_quickadd.tpl',
        'Backbone.CollectionView',
        'Backbone.View',
        'C3.ShoppingExtensions.CartPage.QuickAdd.List.View',
        'Backbone',
        'ItemsSearcher.Collection',
        'GlobalViews.Message.View',
        'Utils',
        'LiveOrder.Model'
    ]
, function (
	    c3_shoppingextensions_cartpage_quickadd_tpl,
        BackboneCollectionView,
        BackboneView,
        ListView,
        Backbone,
        ItemsSearcherCollection,
        GlobalViewsMessageView,
        Utils,
        LiveOrderModel
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.LoginRegister.View @extends Backbone.View
	return Backbone.View.extend({

	template: c3_shoppingextensions_cartpage_quickadd_tpl,

    events: {
        'keyup [data-action="quickadd-search"]':'searchItems'/*,
        'focusin [data-action="quickadd-search"]':'searchItems'*/
    },

	defaultOptions: {
            timeout:null,
            ajaxDone: false,
        },

    initialize: function (options) 
    {
         this.options = _.defaults(options || {}, this.defaultOptions);
         this.application= options.application;
         this.container = options.container;
         jQuery('body').on('click', this.hideSearchBox);
    },

    searchItems:function(e)
        {
            if(e.which != 40 && e.which != 38 && e.which!=13)
            {
                jQuery("#cartpage-quickadd-searchresults").hide();
                clearTimeout(this.options.timeout);
                var self=this;
                self.options.ajaxDone = false;
                
                this.options.timeout=setTimeout(function() {
                    var searchBoxValue=jQuery('#quickadd-search').val();
                    if(searchBoxValue.length>=3)
                    {
                        Backbone.history.navigate('cart?quickaddkeyword='+searchBoxValue+'', { silent: true });
                        //console.log('searchBoxValue'+searchBoxValue);
                        var collection=new ItemsSearcherCollection();
                        var limit = 4
                        collection.fetch({
                                data: 
                                {
                                    q: String(searchBoxValue).trim(),
                                    sort: self.options.sort,
                                    limit: limit,
                                    offset: 0
                                },
                            killerId: _.uniqueId('ajax_killer_')
                        },
                        { 
                            silent: true
                        }).done(function(result) {
                            self.options.ajaxDone = true;
                            var items=_.compact(result.items);
                            if(items.length > 0)
                            {
                                var itemsView = new ListView({collection: collection, application: this.application});
                                jQuery("#cartpage-quickadd-searchresults").show();
                                jQuery("#cartpage-quickadd-searchresults").html(itemsView.render().$el.html());
                                //jQuery('#view-all').attr('data-url',"/search?keywords="+searchBoxValue) 
                                self.bindEvents();
                            }
                        });
                    }
                }, 500);
            }
        },
        hideSearchBox: function(e)
        {
            var container = jQuery("#quickadd-items-search-collection");
            
            if (!container.is(e.target) && container.has(e.target).length === 0) 
                jQuery("#cartpage-quickadd-searchresults").hide();
            else
                jQuery("#cartpage-quickadd-searchresults").show();
        },

        addQuantity: function(e)
        {
                var self = this;

                var $element = jQuery(e.currentTarget);
                var quantity_input = $element.parent().find('.item-quantity-value');
                var button_minus = $element.parent().find('.minus-button');
                var find_title_ele = $element.closest('.e2');
                var cart = this.container.getComponent('Cart');
                var lines=[];

                var itemQtyInCurrentOrder = 0;

                var liveOrder = LiveOrderModel.getInstance();
                //console.log(quantity_input)

                var internalID=quantity_input.attr("data-id");

                //console.log(internalID)
                
                var lineData=liveOrder.get('lines').filter(function(line)
                {   
                    return line.get('item').get('internalid') == internalID;
                });
                
                if(lineData.length > 0)
                {
                var lineQuantity=lineData[0].get('quantity');
                itemQtyInCurrentOrder = lineQuantity;
                }

                var elementParent = $element.parent('.plus-icon');      
                //console.log(elementParent)

                var trashCane = $element.parent().find('.product-trash-tray');
                
               // console.log(find_title_ele)
                quantity_input.show();
               // button_minus.show();

                var parentEle = $element.parent('.plus-icon');
                if(!(parentEle.hasClass('expand-plus-icon')))
                parentEle.addClass('expand-plus-icon');

                find_title_ele.addClass('newly-added-css');
                
                var old_value = quantity_input.text();

                 if(elementParent.hasClass('add-to-cart-buttons-opened'))
                 {
                var new_val = parseFloat(old_value) == 0 ? 1 : parseFloat(old_value)+1; 
                quantity_input.text(new_val);
                }
                
                var quantity = quantity_input.text();
                var internalID=quantity_input.attr("data-id");
                //console.log(internalID)

                if(quantity == 1)
                {
                    trashCane.show();
                    button_minus.hide();
                    quantity_input.css('text-align','left');
                    
                }
                else    
                {
                     button_minus.show();
                    trashCane.hide();
                    quantity_input.css('text-align','center');
                }

               // console.log(quantity)
                
                if(quantity>0)
                {
                    if(itemQtyInCurrentOrder && !(elementParent.hasClass('add-to-cart-buttons-opened')))
                    {
                        $element.text('+');
                        $element.removeClass('plus-button-additional');

                        elementParent.addClass('add-to-cart-buttons-opened');
                        elementParent.removeClass('plus-icon-additional');

                    }else
                    {
                        var lineData={quantity: parseFloat(1),
                                      item: {internalid: parseFloat(internalID)}
                        };
                        lines.push(lineData);
                        SC.loadingIndicatorShow();
                        cart.addLines({lines: lines}).then(function() {
                            SC.loadingIndicatorHide();
                            setTimeout(function(){
                                if(!Utils.isPhoneDevice())
                                    jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");
                            }, 500);
                        });
                        elementParent.addClass('add-to-cart-buttons-opened');   
                    }
                }
        },

        removeQuantity: function(e)
        {
                const $element = jQuery(e.currentTarget);
                const quantity_input = $element.parent().find('.item-quantity-value');
                const find_title_ele = $element.closest('.e2');
                const old_value = quantity_input.text();
                const cart = this.container.getComponent('Cart');
                var lines=[];

                if(old_value==1 )
                {
                    var parentEle = $element.parent('.plus-icon');
                    if(parentEle.hasClass('expand-plus-icon'))
                    parentEle.removeClass('expand-plus-icon');

                    find_title_ele.removeClass('newly-added-css');
                    let new_val = parseFloat(old_value) - 1;
                    quantity_input.text(new_val);
                    $element.attr("style","display:none !important;");
                    quantity_input.hide();
                }
                else if(old_value>1 ){
                    let new_val = parseFloat(old_value) - 1;
                    quantity_input.text(new_val);

                    if(old_value == 2)
                    {
                        var trashCane = $element.parent().find('.product-trash-tray');
                        var button_minus = $element.parent().find('.minus-button');
                        //console.log(button_minus)
                        button_minus.attr("style","display:none !important;");
                        trashCane.show();
                        quantity_input.css('text-align','left');
                        
                    }
                }
                var internalID=quantity_input.attr("data-id");
                
                var liveOrder = LiveOrderModel.getInstance();
                
                var lineData=liveOrder.get('lines').filter(function(line)
                {   
                    return line.get('item').get('internalid') == internalID;
                });
                var lineQuantity=lineData[0].get('quantity');
                
                if(lineQuantity==1)
                    liveOrder.removeLine(
                    lineData[0].set('quantity',parseFloat(lineQuantity)-1));
                else
                {
                    liveOrder.updateLine(
                    lineData[0].set('quantity',parseFloat(lineQuantity)-1));
                    setTimeout(function(){
                        if(!Utils.isPhoneDevice())
                            jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");
                    }, 500);
                }
        },

        bindEvents:function bindEvents(){
            var self = this;
            
            // Serial/lot items don't get a plus icon; route them to the PDP instead.
            // The whole Quick Add box is wrapped in <a data-action="quick-order-dropdown"> by the theme,
            // and CartPage.js registers a QuickOrder.View delegate on that action which calls
            // preventDefault(). Without stopPropagation() here the outer handler swallows the click
            // and our anchor never navigates. We do NOT preventDefault() ourselves � the anchor's
            // default href navigation is what we want (also lets middle-click / Cmd-click open a new tab).
            this.$el.find('[data-action="quickadd-select-serial"]').on('click', function(e){
                e.stopPropagation();
                jQuery("#cartpage-quickadd-searchresults").hide();
            });

            this.$el.find('[data-action="plus"]').on('click', function(e){
                
                self.addQuantity(e);
                /*const $element = self.$(e.target);
                const quantity_input = $element.parent().find('input');
                const old_value = quantity_input.val();
                if(old_value>0)
                {
                    let new_val = parseFloat(old_value) + 1;
                    quantity_input.val(new_val);
                }*/
            });
            this.$el.find('[data-action="minus"]').on('click', function(e){
                self.removeQuantity(e);
               /* const $element = self.$(e.target);
                const quantity_input = $element.parent().find('input');
                const old_value = quantity_input.val();
                if(old_value>1)
                {
                    let new_val = parseFloat(old_value) - 1;
                    quantity_input.val(new_val);
                }*/
            });
            /*this.$el.find('[data-action="add-to-cart"]').on('click', function(e){
                self.quickAddToCart(e);
            });
            this.$el.find('[data-action="view-all"]').on('click', function(e){
                var url = jQuery('#view-all').attr('data-url');
                Backbone.history.navigate(url, { trigger: true });
                self.hideSearchBox(e);

            });*/
        },
        quickAddToCart:function(e)
        {
            var self=this;
            const $element = self.$(e.target);
            var quantityInput=$element.attr('data-quantity');

            var internalID=$element.attr('data-internalid');
            var quantityData= jQuery('#'+quantityInput).val() ;
            var cart = this.application.getComponent('Cart');
            cart.addLine({
                line: {
                    quantity: parseFloat(quantityData),
                    item: {
                        internalid: internalID
                    }
                }
            }).then(function() {
                /*var Layout = SC.Application('Shopping').getComponent('Layout');
                const message=Utils.translate('Item has been added to Quote')   
                var view= new GlobalViewsMessageView({
                        message: message,
                    }); 
                Layout.showContent(view, {showInModal: true});  */ 
                jQuery("#cartpage-quickadd-searchresults").hide();
                //jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");
            });
        },
        /*destroy: function() 
        {
            this.$searchElement.off('click');

            BackboneView.prototype.destroy.apply(this, arguments);
        },*/


		//@method getContext @return NXTurn.ShoppingExtensions.LoginRegister.View.Context
	   getContext: function getContext()
		{
            var currentURL = window.location.href
            ,   keywordFromUrl = ''
            

            if(currentURL.indexOf('?quickaddkeyword') > -1)
                keywordFromUrl = currentURL.split('?quickaddkeyword=');

			return {
                searchKeyWordFound : keywordFromUrl ? keywordFromUrl[1] : ''
			};
		}
	});
});
